export default __webpack_public_path__ + "static/media/favicon.c49a9905.png";